document.addEventListener('DOMContentLoaded', function () {
  if (window.wishlist_io_enabled) {
    console.log("wishlist_io_enabled");
  const stockEl = document.querySelector("#stockinstore-wrapper").parentNode;
  const wishlistBtn = document.querySelector("#btn-detail-wishlist");
  if (stockEl && wishlistBtn) {
    stockEl.style.width = "83%";
    stockEl.parentNode.style.display = "flex";
    stockEl.parentNode.style.justifyContent = "space-between";
    stockEl.parentNode.style.alignItems = "center";
    wishlistBtn.style.height = "53px";
   // stockEl.insertAdjacentElement("afterend", wishlistBtn);
    wishlistBtn.style.opacity = "1";
    wishlistBtn.style.display = "flex";
  }
  } else {
    console.log("wishlist_io_disabled");
    const stockEl = document.querySelector("#stockinstore-wrapper");
    const wishlistBtn = document.querySelector("wishlist-btn");

    if (stockEl && wishlistBtn) {
      stockEl.style.width = "80%";
      stockEl.parentNode.style.display = "flex";
      stockEl.parentNode.style.justifyContent = "space-between";
      stockEl.insertAdjacentElement("afterend", wishlistBtn);
      wishlistBtn.style.opacity = "1";
      wishlistBtn.style.display = "flex";
    }
}

  const mainProductInfo = document.querySelector('#product-info');
  if (!mainProductInfo) return;

  const variantInputs = Array.from(mainProductInfo.querySelectorAll('[data-single-option-selector]'));
  console.log('variantInputs', variantInputs);
  if (!variantInputs.length) return;

  const groups = {};
  variantInputs.forEach(input => {
    const idx =
    input.dataset.index ||
    input.dataset.optionPosition ||
    input.name ||
    'option1';
    if (!groups[idx]) groups[idx] = [];
    groups[idx].push(input);
    try { input.checked = false; } catch(e){}
    input.removeAttribute && input.removeAttribute('checked');
  });
  const containerSize = document.querySelector('.size-option-infor');

  if (containerSize) {
    containerSize.innerHTML = "";
  }

  // Only gate the main product's own add-to-cart button(s) — not Quick Add buttons on other products
  // rendered elsewhere on the page (Compare Similar Products, Related Products, Shop the Look, etc.),
  // which each belong to a different product and shouldn't be blocked by this product's variant selection.
  // The desktop sticky add-to-cart bar renders its button outside #product-info but links back to the
  // same product form via the "form" attribute, so it's matched by form id rather than DOM containment.
  const mainAddButton = mainProductInfo.querySelector('[data-add-to-cart]');
  const mainFormId = mainAddButton ? mainAddButton.getAttribute('form') : null;
  const addButtons = Array.from(document.querySelectorAll('[data-add-to-cart]')).filter(function (btn) {
    return mainProductInfo.contains(btn) || (mainFormId && btn.getAttribute('form') === mainFormId);
  });
  addButtons.forEach(btn => {
    if (!btn.hasAttribute('disabled')) {
      btn.classList.add('needs-selection');
      btn.disabled = false;
    }
  });

  function allGroupsSelected() {
    return Object.keys(groups).every(key => groups[key].some(i => i.checked));
  }

  function clearAlerts() {
    document.querySelectorAll('.size-alert').forEach(n => n.remove());
  }

  function showSizeAlert() {
    clearAlerts();

    const container = document.querySelector('.size-option-infor');
    if (!container) return;

    const alert = document.createElement('div');
    alert.className = 'size-alert';
    alert.setAttribute('role', 'alert');
    alert.style.color = '#C36A5B';
    alert.style.fontSize = '14px';
    alert.style.textAlign = 'center';
    alert.textContent = 'Please select a size';

    container.innerHTML = '';  
    container.appendChild(alert);

    alert.scrollIntoView({ behavior: 'smooth', block: 'center' });

    const firstUncheckedGroup = Object.keys(groups)
      .map(k => groups[k])
      .find(g => !g.some(i => i.checked));
    if (firstUncheckedGroup && firstUncheckedGroup[0]) {
      try { firstUncheckedGroup[0].focus(); } catch(e){}
    }
  }

  variantInputs.forEach(input => {
    input.addEventListener('change', function () {
      if (allGroupsSelected()) {
        addButtons.forEach(btn => {
          btn.classList.remove('needs-selection');
        });
        clearAlerts();
      }
    });
  });

  addButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      if (!allGroupsSelected()) {
        e.preventDefault();
        e.stopPropagation();
        showSizeAlert();
        return;
      }
    });
  });
});
